import React from "react";
import styles from "./BrandMark.module.css";

/**
 * The ContxtIQ mark, painted in the surrounding text color — pass it as the
 * logo slot of a chrome component (e.g. `GlobalNavRail`'s `headingIcon`).
 *
 * Decorative: the wordmark beside it carries the name, so this is hidden from
 * assistive technology.
 */
const BrandMark = (): React.ReactElement => {
  return <span className={styles.mark} aria-hidden="true" />;
};

export default BrandMark;
